import { ERROR_MESSAGE_KEYS } from '@app/constants/analyticsConstants';
import { getPartName } from '@app/utils/commonUtils';
import { getFireErrorTrackingEvent } from './useAnalytics';

const userSensitiveInfo = [
  'logonId',
  'lastName',
  'firstName',
  'firstNameSearchType',
  'lastNameSearchType',
  'logonIdSearchType'
];

export const getStringFromObjectEntries = (obj = {}, separator = '&') =>
  Object.entries(obj)
    .filter(([key]) => !userSensitiveInfo.includes(key))
    .map(([key, val]) => `${key}:${val}`)
    .join(separator);

export const getGACheckoutValidProductAttributes = ({
  item,
  index,
  emailCart
}) => {
  const {
    orderItemExtendAttribute: {
      googleAnalyticsAttributes: {
        category,
        brand,
        checkFitment,
        classification,
        kitId,
        packageFlag,
        relatedModel
      } = {},
      unitWeight
    } = {}
  } = item;

  return {
    name: getPartName(item.partNumber, item.name),
    list: item.page,
    id: item.partNumber,
    price: !emailCart ? item.unformattedUnitPrice : '',
    brand: brand,
    category: category,
    inventoryStatus: !emailCart
      ? item.availability?.[0]?.availabilityMessage
      : '',
    classification: classification,
    productWeight: !emailCart ? unitWeight : '',
    kitId: kitId,
    packageFlag: packageFlag,
    checkFitment: checkFitment,
    relatedModel: relatedModel,
    productAttributesVisible: '',
    msrp: '',
    position: index + 1,
    quantity: item.serverQuantity || item.quantity || '',
    availability: item.availability,
    sourcingDetails: item.sourcingDetails || []
  };
};

export const getGACheckoutProducts = ({ products, emailCart }) =>
  products.map((item, index) =>
    getGACheckoutValidProductAttributes({
      item,
      index,
      emailCart
    })
  );

export const getErrorMessage = (errorType, t) => {
  const key = ERROR_MESSAGE_KEYS[errorType];

  return key ? t(key) : '';
};

export const fireErrorTrackingEvent = (...props) => {
  const fireEvent = getFireErrorTrackingEvent();
  fireEvent(...props);
};
